import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import * as utils from "../../../utils.js";

export default class VistaGrupoTrabajo extends Component {
  mostrarFinalidad() {
    let finalidades = "";
    if (this.props.Finalidad) {
      for (let i = 0; i < this.props.Finalidad.length; i++) {
        //finalidades.push(<p>{this.props.Finalidad[i].type}</p>);
        finalidades = this.props.Finalidad[i].type + " " + finalidades;
      }
    }
    if (finalidades === "") {
      finalidades = "No hay finalidades asignadas actualmente";
    }

    return finalidades;
  }

  render() {
    return (
      <React.Fragment>
        <Container className="mb-3">
          <Row>
            <Col lg="4" className="border">
              <h6>Nombre Equipo/Comisión</h6>
              <p>{this.props.DatosGrupoTrabajo.name}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Fecha de Creación</h6>
              <p>{utils.formatDate(this.props.DatosGrupoTrabajo.creationDate)}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Fecha de Cierre</h6>
              <p>{utils.formatDate(this.props.DatosGrupoTrabajo.endDate)}</p>
            </Col>
          </Row>
          <Row>
            <Col lg="4" className="border">
              <h6>Email</h6>
              <p>{this.props.DatosGrupoTrabajo.email}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Tipo</h6>
              <p>{this.props.DatosGrupoTrabajo.type}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Nivel</h6>
              <p>{this.props.DatosGrupoTrabajo.level}</p>
            </Col>
          </Row>
          <Row className="border">
            <Col>
              <h6>Finalidades</h6>
              <p>{this.mostrarFinalidad()}</p>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
